import constants from '../../../Constants';
import interactionParserUtils from './InteractionParserUtils';

const customOralParser = {
    parse(interaction, language, defaultLanguage) {
        return {
            prompt: interactionParserUtils.getPrompt(interaction, language, defaultLanguage),
            type: constants.interactionType.CUSTOM_INTERACTION_ORAL,
        };
    },
};

export default customOralParser;
